export default () => {
    $(".input-group.searcher-2 input[type='text']").on("click", function(){
        $(".input-group.searcher-2").addClass("active-input");
    });

    $(".input-group.searcher-2").on('focusout', function () {
        $(".input-group.searcher-2").removeClass("active-input");
    });
}
